"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PART_INPUT = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Types_1 = require("Types");
const Typography_1 = require("../../UI/Typography");
const style = __importStar(require("./styled"));
const Hooks_1 = require("@/Hooks");
const useOnOutsideClick_1 = require("@/Hooks/useOnOutsideClick");
const PartInput_1 = __importDefault(require("./PartInput"));
const cart_1 = require("@/Endpoints/cart");
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const cart_2 = require("@/Redux/Actions/cart");
const Utils_1 = require("@/Utils");
const Skeleton_1 = __importDefault(require("../../UI/Skeleton/Skeleton"));
const styled_components_1 = require("styled-components");
const callAddToCartEvent_1 = require("@/Utils/callAddToCartEvent");
const svg_components_1 = require("app/assets/svg-components");
exports.PART_INPUT = 'partInputs';
const QuickOrderBlock = ({ title, text, setQuickOrderErrors, setQuickOrderNotifications, quickOrderNotifications, quickOrderErrors, isReady }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [partInputs, setPartInputs] = (0, react_1.useState)([{ id: (0, uniqueId_1.default)(`${exports.PART_INPUT}-`), amount: 1, partNo: '' }]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const containerRef = (0, react_1.useRef)(null);
    const { t } = (0, Hooks_1.useTranslate)();
    const theme = (0, styled_components_1.useTheme)();
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, useOnOutsideClick_1.useOnOutsideClick)(containerRef, () => {
        setOpen(false);
    });
    const { width } = (0, Hooks_1.useWindowSize)();
    const onSubmit = () => {
        // TODO: Change to use a common hook for these quick order functions in QuickOrderBlock.tsx and QuickOrderPage.tsx
        setIsLoading(true);
        const payload = partInputs.map(el => {
            return { code: el.partNo, quantity: el.amount };
        });
        (0, cart_1.putlistQuickorder)({ items: payload })
            .then(result => {
            var _a, _b;
            const productStatuses = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.productStatuses;
            const { newProductNotificationsObj, newErrorsObj, productNotificationsObj } = (0, Utils_1.generateErrorsAndNotifications)(productStatuses, t, quickOrderNotifications, quickOrderErrors);
            if ((_b = Object.values(productNotificationsObj)) === null || _b === void 0 ? void 0 : _b.length) {
                dispatch((0, cart_2.setCartData)(result.data.cart));
            }
            setQuickOrderNotifications([...Object.values(newProductNotificationsObj)]);
            setQuickOrderErrors([...Object.values(newErrorsObj)]);
            (0, callAddToCartEvent_1.callAddToCartEvent)(result.data);
        })
            .finally(() => {
            setIsLoading(false);
            setOpen(false);
            setPartInputs([{ id: `${exports.PART_INPUT}-`, amount: 1, partNo: '' }]);
        });
    };
    const addNewRow = (e) => {
        e.preventDefault();
        setPartInputs(prev => [...prev, { id: (0, uniqueId_1.default)(`${exports.PART_INPUT}-`), amount: 1, partNo: '' }]);
    };
    const onPaste = (e, index) => {
        (0, Utils_1.onPasteHandler)(e, index, setPartInputs, partInputs);
    };
    return (react_1.default.createElement(style.Container, { ref: containerRef },
        react_1.default.createElement(style.ButtonWithDropdownContainer, null,
            !isReady ? (react_1.default.createElement(Skeleton_1.default, { width: theme.constants.productpage.mobileDescHeight, height: theme.spacing.m5 })) : (react_1.default.createElement(style.ButtonWithIcon, { variant: Types_1.ButtonVariants.ICON_BUTTON, onClick: () => setOpen(true) },
                react_1.default.createElement(style.ZapIcon, null),
                t('/haldex/quick_order/button_label'))),
            open && (react_1.default.createElement(style.OrderContainer, { open: open, width: width },
                react_1.default.createElement(style.TopRow, null,
                    react_1.default.createElement(style.Title, { type: Typography_1.Types.H5 }, title),
                    react_1.default.createElement(style.CloseButton, { onClick: () => setOpen(false) },
                        react_1.default.createElement(svg_components_1.CrossIcon, null))),
                react_1.default.createElement(style.SubText, { type: Typography_1.Types.BODY_1 }, text),
                react_1.default.createElement(style.PartInputsContainer, null, partInputs.map((input, index) => (react_1.default.createElement(style.InputRow, { key: index },
                    react_1.default.createElement(PartInput_1.default, { setPartInputs: setPartInputs, defaultPartNo: input.partNo, defaultAmount: input.amount, index: index, onPaste: onPaste, disabled: isLoading }),
                    react_1.default.createElement(style.ButtonBlock, null,
                        partInputs.length - 1 === index && (react_1.default.createElement(style.NewRowButton, { disabled: isLoading, variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: e => addNewRow(e) },
                            react_1.default.createElement(style.NewRowText, { type: Typography_1.Types.BODY_2 },
                                "+ ",
                                t('/haldex/quick_order/add_rows')))),
                        partInputs.length !== 1 && (react_1.default.createElement(style.CloseButton, { disabled: isLoading, deleteRow: true, onClick: () => (0, Utils_1.deleteInputHandler)(index, isLoading, setPartInputs) },
                            react_1.default.createElement(svg_components_1.CrossIcon, null)))))))),
                react_1.default.createElement(style.AddToCartButton, { variant: Types_1.ButtonVariants.DEFAULT, onClick: onSubmit, disabled: (partInputs && partInputs.some(part => part.partNo === '')) || isLoading }, isLoading ? react_1.default.createElement(style.LoaderIcon, null) : t('/haldex/quick_order/add_to_cart')))))));
};
exports.default = QuickOrderBlock;
